"use client";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <div>
      <h2>Sorry, kamer gegevens konden niet geladen worden.</h2>
      <p style={{ opacity: 0.8 }}>{error.message}</p>
      <button onClick={() => reset()} style={{ padding: 8, marginTop: 12 }}>
        Opnieuw proberen
      </button>
    </div>
  );
}
